import React, {Component} from "react"

const url = require('./Icons.svg')


class Icon extends Component {
    render() {
        const { name, active } = this.props;
        return (
            <svg className={`icon-symbol ${active ? 'active' : ''}`}>
                <use xlinkHref={url + '#icon-' + name}/>
            </svg>
        )
    }
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js